import { render } from "./TermsContent.vue?vue&type=template&id=1f586ca0&scoped=true"
import script from "./TermsContent.vue?vue&type=script&lang=js"
export * from "./TermsContent.vue?vue&type=script&lang=js"

import "./TermsContent.vue?vue&type=style&index=0&id=1f586ca0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f586ca0"]])

export default __exports__